// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"7417b1c7","780":"aff54a75"}[chunkId] + ".chunk.js";
};